<template>
<div>
<div class="modal" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header p-2">
        <h6 class="modal-title">Select Screen(s)</h6>
        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeFieldsBrowse">
          <span aria-hidden="true"><cancel-icon class="close-icon" style="height: 30px !important;
    width: 30px !important;
    color: #fff;"></cancel-icon></span>
        </button>
      </div>
      <div class="modal-body">
          <div class="col-md-12 search-bar-comm-style">
                <input type="text" v-model="filterFieldBy" class="bg-transparent rounded text-light" style="width:45%" ref="focus"
                     @input="getFieldsOnKeyup()" placeholder="Search field...">
                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-search" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                    <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                </svg>
            </div>
            <div class="col-md-12 mt-3" style="height:87%">
                <ul v-if="fieldListFromAutocomplete.length !=0" class="tags-display-ul p-0 active-tag">
                         <li id="tag_field" v-for="field in fieldListFromAutocomplete" :key="field._id" v-on:click="selectField(field)"
                         :class="{activeScreen: fieldIdList.includes(field._id) }" class='view-tags'>
                         <span>{{field.name}}</span>
                        </li>
                </ul>
            </div>
      </div>
        <div class="modal-footer p-0 primary-btn-style">
            <div>
                <button class="btn btn-outline-secondary mr-3" data-dismiss="modal" @click="closeFieldsBrowse">Cancel</button>
                <button class="btn btn-outline-primary ml-1 mr-2" v-on:click="saveAndCloseBrowser">Add</button>
            </div>
        </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import cancelIcon from "../core/InlineCancelField.vue"

export default {
    props:['selectedScreenFieldIds'],
    data(){
        return{
            startUpFieldsList:[],
            filterFieldBy: "",
            fieldIdList:[],
            selectedFieldIdList:[],
            fieldListFromAutocomplete:[]
        };
    },
    components:{
        'cancel-icon':cancelIcon
    },
    methods:{
        selectField(fieldInfo){
          if(!this.fieldIdList.includes(fieldInfo._id)){
            this.fieldIdList.push(fieldInfo._id)
          }else{
            this.fieldIdList.splice(this.fieldIdList.indexOf(fieldInfo._id),1);
          }
        },
        clearFieldFilter(){
            this.filterFieldBy="";
            this.getFieldsOnKeyup();
        },
        saveAndCloseBrowser(){
          if(typeof(this.fieldIdList) == "undefined"){
            this.$emit('close',[])
            return
          }
          this.$emit('close', this.fieldIdList)
        },
        closeFieldsBrowse(){
          if(typeof(this.selectedFieldIdList) == "undefined"){
            this.$emit('close',[])
            return
          }
          this.$emit('close', this.selectedFieldIdList)
        },
        getFieldsOnKeyup(){
            let loadAll = true;
            if(typeof this.filterFieldBy !="undefined" && this.filterFieldBy.length > 0){
                let fieldList = this.startUpFieldsList.filter((_field)=>_field.name.toLowerCase().startsWith(this.filterFieldBy.toLocaleLowerCase()))
                if(typeof fieldList != "undefined" && fieldList.length > 0){
                    this.fieldListFromAutocomplete = fieldList;
                    loadAll = false;
                }else{
                    this.fieldListFromAutocomplete = [];
                    loadAll = false;
                }
            }
            if(loadAll){
                this.fieldListFromAutocomplete = this.startUpFieldsList;
            }
        },
        ...mapGetters("startUpData",["getStartUpDataFromInCache"])
    },
    created(){
        if(Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
            this.startUpFieldsList = this.getStartUpDataFromInCache()["screens"];
        }
        let idList = this.selectedScreenFieldIds;
        Object.assign(this.selectedFieldIdList, idList);
        for(let k = 0; k<this.selectedScreenFieldIds.length; k++){
          this.fieldIdList.push(this.selectedScreenFieldIds[k])
        }
        this.getFieldsOnKeyup();
    }
}
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;
$icon-hover:#2c3339;
.modal-dialog {
    max-width: 500px;
    width: 500px;
    height: 500px;
    margin: 0;
    padding: 0;
  }
  
   .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height:300px;
      overflow:auto;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
.border{
    border: $border-color !important;
}

.activeScreen{
    color: $active-blue;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    .modal-title{
      color:$text-color;
    }
}

.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
     margin:0px !important;
    padding: 0px !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style {
  margin-top: 1%;
  height:55px;
  button {
    height: 35px;
    width: 70px;
    border-radius: 5px;
    font-size:14px;
  }
}

.search-bar-comm-style{
  height:30px;
  position:relative;
  input{
    border:$border-color;
    height: 25px;
    padding-inline-start: 6%;
  }
  svg{
    position: absolute;
    inset-inline-start:21px;
    top: 58%;
  }
}

.secondary-btn-style{
  color:$text-color;
}

.modal-footer{
    justify-content: flex-end;
}

.view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: $tags-border-color !important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    span{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
}

.view-tags:hover{
    border: $tags-border-color !important;
}

.activeTag{
    color: $active-blue !important;
}

.secondary-btn-style:hover{
  text-decoration: underline;
}

// //pagination
::v-deep {
.page-item.disabled .page-link {
  background-color: #0d0d0d !important;
  border: 1px solid #333 !important;
  // border: none;
}
.page-item.active .page-link {
  background-color: #0d0d0d !important;
  // border: none !important;
  border: 1px solid #333 !important;
  color:$active-blue;
}
.page-link {
  background-color: #0d0d0d !important;
  border: 1px solid #333 !important;
  // border: none !important;
  color:$text-color;
  padding: 5px !important;
}
.page-link:hover {
  background-color: #1a1a1a !important;
}
.pagination {
  float: inline-end;
  margin-bottom: 0px !important;
  margin-inline-end: 8px;
}
.VuePagination__count {
  color: #797979 !important;
  margin-bottom: 0px !important;
  font-size: 12px;
  margin-inline-end: 7px;
  margin-top: 1px;
  float:inline-start;
  display:none;
  margin-inline-start:5px;
}
.VuePagination__pagination-item {
    font-size: 14px;
    width: 27px;
}
.VuePagination__pagination-item-prev-chunk {
  display:none;
}
.VuePagination__pagination-item-next-chunk{
  display:none;
}
.VuePagination__pagination-item-prev-page{
  width:50px !important;
}

.VuePagination__pagination-item-next-page{
  width:50px !important;
}

.VuePagination__pagination-item-next-page a:before{
  width:50px;
  content: "next ";
}

.VuePagination__pagination-item-prev-page a:after{
  width:50px;
  content: " prev";
}
.v-list{
  padding:0px !important;
}
.v-list-item{
  text-align: start;
  border: 1px solid #242424 !important;
  min-height: 37px !important;
  padding: 0 10px !important;
  font-size: 12px !important;
    .v-list-item__title{
          font-size: 14px !important;
          color:$text-color !important;
    }
  }
.v-menu__content{
  width:150px !important;
}
}
.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}
</style>